import {
    Component, DoCheck, EventEmitter,
    Input, OnDestroy,
    OnInit, Output, ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CaptchaComponent } from '../captcha/captcha.component';


@Component({
    selector: 'app-enter-phone',
    templateUrl: './enterPhone.component.html',
    styleUrls: ['./enterPhone.component.scss'],
})
export class EnterPhoneComponent implements OnInit, OnDestroy, DoCheck {

    private _catchaValidationErrorTranslate: string;

    constructor(
        private _translateService: TranslateService
    ) {
    }

    public submitProcessing: boolean;
    public errorText: string;
    public captchaCode: string;
    @Input() phoneValueWithRegion: string;
    @Output() phoneValueWithRegionChange = new EventEmitter<string>();
    @Input() submitButtonText: string;
    @Output() submited = new EventEmitter();
    @ViewChild('captchaComponent') captchaComponent: CaptchaComponent;

    ngOnInit(): void {
        this._initTranslations();
    }

    ngDoCheck(): void {
    }

    ngOnDestroy(): void {
    }

    private _initTranslations() {
        this._translateService.get(
            [
                'Common.CaptchaValidationError',
            ])
            .subscribe(
                result => {
                    this._catchaValidationErrorTranslate = result['Common.CaptchaValidationError'];
                });
    }

    public submitButtonClick(event: Event): void {
        this.errorText = null;

        this.submitProcessing = true;
        this.submited.emit();
    }

    public captchaError(): void {
        this.submitProcessing = false;
        this.errorText = this._catchaValidationErrorTranslate;
        this.captchaComponent.refreshCaptcha();
    }

    public clear() {
        this.errorText = null;
        this.submitProcessing = false;
        this.phoneValueWithRegion = null;
        this.captchaComponent.refreshCaptcha();
    }

}
